<template>
  <transition name="suggested-address">
    <v-col
      v-if   = "addressValidation.showSuggestedAddress"
      sm     = "12"
      class  = "overflow-hidden"
      :style = "outerStyle"
    >
      <v-card
        class     = "mb-2 border--warning overflow-hidden"
        elevation = "3"
        outlined
      >
        <v-card-title class="warning--text">
          Suggested Address
        </v-card-title>
        <v-row
          v-if = "splitSuggestedAddress"
          dense
        >
          <v-col sm="12" md="5">
            <v-text-field
              :value  = "addressValidation.response.googleCorrectedAddress?.street ?? ''"
              label   = "Street"
              ref     = "Suggested Street"
              color   = "warning"
              class   = "mx-sm-2 ml-md-4 mr-md-0"
              readonly
              dense
            ></v-text-field>
          </v-col>
          <v-col sm="12" md="3">
            <v-text-field
              :value = "addressValidation.response.googleCorrectedAddress?.city ?? ''"
              label  = "City"
              ref    = "Suggested City"
              color  = "warning"
              class  = "mx-sm-2 mx-md-0"
              readonly
              dense
            ></v-text-field>
          </v-col>
          <v-col sm="12" md="2">
            <v-text-field
              :value = "addressValidation.response.googleCorrectedAddress?.state ?? ''"
              label  = "State"
              ref    = "Suggested State"
              color  = "warning"
              class  = "mx-sm-2 mx-md-0"
              readonly
              dense
            ></v-text-field>
          </v-col>
          <v-col sm="12" md="2">
            <v-text-field
              :value = "addressValidation.response.googleCorrectedAddress?.zipcode ?? ''"
              label  = "Zipcode"
              ref    = "Suggested Zipcode"
              color  = "warning"
              class  = "mx-sm-2 mr-md-4 ml-md-0"
              readonly
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-else dense>
          <v-col sm="12">
            <v-text-field
              :value = "addressValidation.getSuggestedAddress()"
              label  = "Street"
              ref    = "Suggested Street"
              color  = "warning"
              class  = "mx-sm-2 mx-md-4"
              readonly
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-card-actions class="flex-sm-column flex-md-row">
          <v-btn
            color  = "warning"
            class  = "mr-sm-0 mr-md-1 mb-sm-2 mb-md-0"
            @click = "() => {
              callbackToUseSuggestedAddress();
              addressValidation.setValid();
            }"
            text
          >
            Use Suggested Address
          </v-btn>
          <v-btn
            color  = "warning"
            class  = "mb-sm-1 mb-md-0"
            @click = "addressValidation.setValid()"
            text
          >
            Use Your Address
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </transition>
</template>


<script lang="ts">
import Vue from "vue";
import { AddressValidationState } from "@/models/ApplicationFormClasses";


export default Vue.extend({
  name: "SuggestedAddressComponent",

  inject: [
    '$applicationFormService'
  ],

  props: {
    addressValidation: {
      type: AddressValidationState,
      required: true
    },
    callbackToUseSuggestedAddress: {
      type: Function,
      required: true
    },
    splitSuggestedAddress: {
      type: Boolean,
      default: false
    },
    outerStyle: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
    }
  },

  methods: {
  }

});
</script>


<style scoped>
/* Starting state for enter */
.suggested-address-enter {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}

/* Active transition phase */
.suggested-address-enter-active,
.suggested-address-leave-active {
  transition:
    max-height 300ms ease-out,
    opacity 300ms ease-out;
}

/* Ending state for enter */
.suggested-address-enter-to {
  max-height: 250px;
  opacity: 1;
  overflow: auto;
}

/* Starting state for leave */
.suggested-address-leave {
  max-height: 250px;
  opacity: 1;
  overflow: hidden;
}

/* Ending state for leave */
.suggested-address-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}
</style>